import { createBrowserHistory } from "history";
import { pathPrefix } from 'DVWebNodeUtils'

export default global.__NATIVEAPP__ ? createBrowserHistory({
  basename: pathPrefix(document.location.pathname)
}) : null;